import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@guards/auth.guard';
import { IonicModule } from '@ionic/angular';

import { ChipToggleModule } from '@components/chip-toggle/chip-toggle.module';
import { FirebaseCampaignBannerModule } from '@components/firebase-campaign-banner/firebase-campaign-banner.module';
import { MarketAssetComponentModule } from '@components/market-asset/market-asset.module';
import { NotificationCloudModule } from '@components/notification-cloud/notification-cloud.module';
import { MarketPage } from './market.page';

const routes: Routes = [
  {
    path: '',
    component: MarketPage,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ChipToggleModule,
    NotificationCloudModule,
    MarketAssetComponentModule,
    FirebaseCampaignBannerModule,
    RouterModule.forChild(routes),
  ],
  declarations: [MarketPage],
  exports: [MarketPage],
})
export class MarketPageModule {}
